// Public actions, to be called by React components.
import {createAction} from 'typesafe-actions';
import {ID} from '../../util/string';

export const loadStarted = createAction(
  '@report/loadStarted',
  action => (reportID: string) =>
    action({
      id: ID(),
      reportID,
    })
);
